import React from 'react'
import style from './Footer.module.css'
import { Link } from 'react-router-dom'
const Footer = () => {
  return (
     <footer className={style.mainFooter}>
      <div className={style.footerContainer}>

        {/* Pages */}
        <div className={style.footerSection}>
          <h3>Pages</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/profile">Profile</Link></li>
          </ul>
        </div>

        {/* Categories */}
        <div className={style.footerSection}>
          <h3>Categories</h3>
          <ul>
            <li><Link to="/Aerobics/1">Aerobics</Link></li>
            <li><Link to="/Exercise/2">Exercise</Link></li>
            <li><Link to="/yoga/5">Yoga</Link></li>
            <li><Link to="/wellness/4">Wellness</Link></li>
            <li><Link to="/Health Tips/3">Health Tips</Link></li>
          </ul>
        </div>

        {/* Popular (same data, different purpose) */}
        <div className={style.footerSection}>
          <h3>Popular</h3>
          <ul>
            <li><Link to="/Aerobics/1">Daily Aerobics</Link></li>
            <li><Link to="/yoga/5">Morning Yoga</Link></li>
            <li><Link to="/Exercise/2">Home Exercise</Link></li>
            <li><Link to="/wellness/4">Wellness Care</Link></li>
          </ul>
        </div>

        {/* Brand */}
        <div className={style.footerSection}>
          <h3 className={style.logo}>Fitness</h3>
          <p className={style.footerText}>
            Our mission is to help you move better, stay active, and live a healthier, stronger, and more balanced lifestyle with guided fitness and wellness videos
          </p>
        </div>

      </div>

      <div className={style.footerBottom}>
        © 2025 Fitness · All Rights Reserved
      </div>
    </footer>
  )
}

export default Footer